import userService from '@/services/user';

export default {
    namespaced: true,

    state: getDefaultState(),

    actions: {
        async syncAll({ state, commit, dispatch }) {
            if (state.syncing) {
                return;
            }

            commit('startSync');
            dispatch('inspections/sendQueue', undefined, { root: true });
            dispatch('checklists/updateAll', undefined, { root: true });
            dispatch('todos/updateAll', undefined, { root: true });
            commit('endSync');
        },
    },

    mutations: {

        startSync(state) {
            state.syncing = true;
        },

        endSync(state) {
            state.syncing = false;
        },

        reset(state) {
            Object.assign(state, getDefaultState());
        },
    },

};

function getDefaultState() {
    return {
        syncing: false,
        needsToSync: false,
    };
}
